module.exports = __webpack_public_path__ + "img/t2-10.273270c2.svg";